// src/app/redux/actions/changeRequestActions.js

export const FETCH_ALL_REQUESTS_REQUEST = 'FETCH_ALL_REQUESTS_REQUEST';
export const FETCH_ALL_REQUESTS_SUCCESS = 'FETCH_ALL_REQUESTS_SUCCESS';
export const FETCH_ALL_REQUESTS_FAIL = 'FETCH_ALL_REQUESTS_FAIL';

export const FETCH_PENDING_FIELDS_REQUEST = 'FETCH_PENDING_FIELDS_REQUEST';
export const FETCH_PENDING_FIELDS_SUCCESS = 'FETCH_PENDING_FIELDS_SUCCESS';
export const FETCH_PENDING_FIELDS_FAIL = 'FETCH_PENDING_FIELDS_FAIL';

export const VALIDATE_REQUEST_REQUEST = 'VALIDATE_REQUEST_REQUEST';
export const VALIDATE_REQUEST_SUCCESS = 'VALIDATE_REQUEST_SUCCESS';
export const VALIDATE_REQUEST_FAIL = 'VALIDATE_REQUEST_FAIL';

export const fetchAllRequests = (companyId) => ({
    type: FETCH_ALL_REQUESTS_REQUEST,
    payload: companyId,
});

export const fetchPendingFields = (userId) => ({
    type: FETCH_PENDING_FIELDS_REQUEST,
    payload: userId,
});

export const validateChangeRequest = (id, status, validatorId, reason, companyId) => ({
    type: VALIDATE_REQUEST_REQUEST,
    payload: { id, status, validatorId, reason, companyId },
});

// Alias pour compatibilité descendante si nécessaire
export const fetchPendingRequests = fetchAllRequests;
